<script>
  console.log("test", mobile)

  import { langId } from "../js/stores.js"
  import { _ } from "svelte-i18n"

  function setLang(id) {
    localStorage.setItem("lang", id)
    $langId = id
  }
</script>

<section id="langSelect" class="section">
  <ul>
    <li
      class="langSelect"
      on:click={() => setLang("en")}
      class:lang-active={$langId === "en"}
    >English</li>
    <li
      class="langSelect"
      on:click={() => setLang("el")}
      class:lang-active={$langId === "el"}
    >Ελληνικά</li>
  </ul>
</section>

<!-- const mobile is defined in index.html -->
{#if !mobile && 1 == 0}
  <section id="google-play-container">
    <a
      href="https://play.google.com/store/apps/details?id=dev.fractalbit.mathjourney"
    >
      <img
        alt={$_("google_play")}
        src={$_("google_play_image")}
        class="google-play-img"
      />
    </a>
  </section>
{/if}

<style>
  #langSelect {
    color: rgba(255, 255, 255, 0.8);
    margin-top: 30px;
  }
  #langSelect ul {
    display: flex;
    align-items: center;
    justify-content: center;
    list-style-type: none;
  }

  #langSelect ul li {
    cursor: pointer;
  }

  #langSelect ul li + li {
    margin-left: 20px;
  }

  .langSelect {
    border-bottom: 5px solid transparent;
    padding: 0px;
    line-height: 2.5rem;
  }
  .lang-active {
    border-bottom: 5px solid #ff7940;
    color: #ff7940;
  }
  .langSelect:hover {
    border-bottom: 5px solid #ff7940;
    color: #ff7940;
  }

  #google-play-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
  }

  @media (max-width: 400px) {
    #langSelect {
      margin-top: 10px;
    }
    #google-play-container {
      margin-top: 10px;
    }
  }
</style>
